import {Component, Input, OnInit} from '@angular/core';
import {LoadingController, ModalController} from "@ionic/angular";
import {IntegrationService} from "../service/integration.service";
import {Constant} from "../shared/model/Constant";
import {Router} from "@angular/router";

@Component({
  selector: 'app-select-product',
  templateUrl: './select-product.page.html',
  styleUrls: ['./select-product.page.scss'],
})
export class SelectProductPage implements OnInit {
  @Input() data: any;
  operator: any;
  selectedSegment: string = "rechargue";
  flagRecharge: boolean;
  providersPackages: any[];
  loading: any;
  suppliers: any[];

  constructor(public modalController: ModalController,
              private integrationService: IntegrationService,
              public loadingController: LoadingController,
              private router: Router,
  ) {
  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    this.getSuppliers();
    this.getPackageSuppliers();

  }

  selectSupplier(supplier) {
    sessionStorage.setItem(Constant.rechargeProvider, JSON.stringify(supplier));
    this.router.navigate(['/recharge']).then(r => console.warn(r));
  }

  selectPackageSupplier(packageSelected) {
    sessionStorage.setItem(Constant.packageProvider, JSON.stringify(packageSelected));
    this.router.navigate(['/packages']).then(r => console.warn(r));
  }

  getSuppliers() {
    this.loading.present();
    this.integrationService.getSuppliers().subscribe((value: any) => {
      this.operator = value;
      this.loading.dismiss();
    });
  }

  segmentChanged(event: any) {
    this.selectedSegment = event.detail.value;
  }

  getPackageSuppliers() {
    this.loading.present();
    this.integrationService.getPackageSuppliers().subscribe((res: any) => {
      this.providersPackages = res;
      this.loading.dismiss();
    });
  }

}
